import { render, staticRenderFns } from "./StaffInfo.vue?vue&type=template&id=7f1a41cf&scoped=true&"
import script from "./StaffInfo.vue?vue&type=script&lang=js&"
export * from "./StaffInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a41cf",
  null
  
)

export default component.exports